import React, { FC } from "react";
import { UserRoleE } from "../../models/enums";
import { useAppSelector } from "../../store/hooks";
import { selectCurrentUser } from "../../store/selectors/authSelectors";
import { isMobileOrTablet } from "../../utils/helpers/mediaQueries";
import AccessRights from "../AccessRights/AccessRights";
import Button, { ButtonModeE } from "../Button/Button";
import { Span } from "../Text/Text";
import Tooltip from "../Tooltip/Tooltip";

import styles from "./styles.module.scss";

type InternalNumberButtonPropTypes = {
  internalNumber: string;
  InternalNumberChangeAllowed: number;
  handleChangeInternalNumber: (internalNumber: string) => void;
};

const InternalNumberButton: FC<InternalNumberButtonPropTypes> = (props) => {
  const {
    internalNumber,
    handleChangeInternalNumber,
    InternalNumberChangeAllowed,
  } = props;
  const user = useAppSelector(selectCurrentUser);

  return (
    <AccessRights accessFor={[UserRoleE.PostProduction]}>
      {internalNumber ? (
        <div className={styles.internalNumberWrapper}>
          <Span>Internal number</Span>
          <Tooltip text="Edit internal number">
            <span
              className={styles.internalNUmberLink}
              onClick={() => handleChangeInternalNumber(internalNumber || "")}
            >
              : {internalNumber || "N/A"}
            </span>
          </Tooltip>
        </div>
      ) : +InternalNumberChangeAllowed === +user?.id ? (
        <>
          <Button
            mode={ButtonModeE.OUTLINED}
            onClick={() => handleChangeInternalNumber(internalNumber || "")}
          >
            Set internal №
          </Button>
          {!isMobileOrTablet() && (
            <Tooltip text="hint internal number">
              <span className={styles.questionMark}>?</span>
            </Tooltip>
          )}
        </>
      ) : undefined}
    </AccessRights>
  );
};

export default InternalNumberButton;
